import { render, staticRenderFns } from "./SpendUsageTable.vue?vue&type=template&id=5dd612d0&"
import script from "./SpendUsageTable.vue?vue&type=script&lang=ts&"
export * from "./SpendUsageTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SpendUsageTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports